
import Group from 'vux/src/components/group/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import BScroll from 'better-scroll';
import pkHeader from  '../common/header/header.vue';
export default {
components:{
Box,
Group,
pkHeader,
Cell,
Icon,
XInput,
Flexbox,
FlexboxItem,
},
data() {
return {
title:"航班信息",
value:'',
showBack:false,
date:'',
totalLine: 0,
data:[],
jbStorage:JSON.parse(localStorage.getItem("jbStorage")) || {}
};
},
methods:{
select(v){

this.$http.post(window.innerAPI + "?server=isAirPortOpenCity",{
"cityNo":v.endCityNo,
}).then(res=>{

if(!res.data.data.data){
this.$vux.toast.show({
text: "抱歉，该航班降落的机场暂未开通接机服务",
type: "text"
})
return;
}
this.jbStorage.airInfo = v
this.jbStorage.airInfo.lineDate =  this.date.split(" ")[0];

var start =  this.$until.updateDate(this.date.split(" ")[0]+" "+v.airLineStartTime),
end =  this.$until.updateDate(this.date.split(" ")[0]+" "+v.airLineEndTime);
if(new Date(end).getTime() < new Date(start).getTime()){
this.jbStorage.airInfo.lineDate = new Date(new Date(end).setMilliseconds(new Date(end).getMilliseconds() +86400000)).format("MM月dd日");
end = new Date(new Date(end).setMilliseconds(new Date(end).getMilliseconds() +86400000)).format("yyyy-MM-dd HH:mm");
}
this.$http.post(window.innerAPI + "?server=checkAirPortServiceTime",{
"cityNo":v.endCityNo,
"endTime": end,
}).then(res=> {
this.jbStorage.airInfo.airDateFault =  res.data.data;

localStorage.setItem("jbStorage",JSON.stringify(this.jbStorage));
this.$router.push('/pickupAircraft')
})

}).catch(function(){

});
},
refresh(){
this.$nextTick(() =>{
this.scroll = new BScroll(this.$refs.seller,{
click:true,
probeType:3
});
});
}
},
mounted(){
this.date = new Date(this.$until.getUrlParam('date')).format('MM月dd日 周W')
if (this.$until.getUrlParam('airNo')){
this.$store.dispatch('showLoading')
this.$http.post(window.innerAPI + "?server=queryAirPortByNo",{
"name":this.$until.getUrlParam('airNo'),
"date":this.$until.getUrlParam('date')
}).then(res =>{
this.data = res.data.data.data
this.$store.dispatch('hideLoading');
this.refresh()
});
} else {
this.$store.dispatch('showLoading')
this.$http.post(window.innerAPI + "?server=queryAirPortByCity",{
"start":this.$until.getUrlParam('start'),
"end":this.$until.getUrlParam('end'),
"date":this.$until.getUrlParam('date')
}).then(res =>{
this.data = res.data.data.data;
this.$store.dispatch('hideLoading');
this.refresh();
});
}
}
};



// WEBPACK FOOTER //
// ./src/components/pickGiveAircraft/serachAircraftList.vue